import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';

export const SECTOR_OPTIONS_DEU = [
  {
    value: FISHING_AND_HUNTING_SECTOR,
    label: 'Landwirtschaft, Forstwirtschaft, Fischerei und Jagd',
  },
  {
    value: MINING_QUARRYING_OIL_AND_GAS_SECTOR,
    label: 'Bergbau, Gewinnung von Steinen und Erden sowie Erdöl- und Erdgasförderung',
  },
  { value: UTILITIES_SECTOR, label: 'Energie- und Wasserversorgung' },
  { value: CONSTRUCTION_SECTOR, label: 'Baugewerbe' },
  { value: MANUFACTURING_SECTOR, label: 'Verarbeitendes Gewerbe' },
  { value: WHOLESALE_TRADE_SECTOR, label: 'Großhandel' },
  { value: RETAIL_TRADE_SECTOR, label: 'Einzelhandel' },
  {
    value: TRANSPORTATION_AND_WAREHOUSING_SECTOR,
    label: 'Verkehr und Lagerei',
  },
  { value: INFORMATION_SECTOR, label: 'Informationswirtschaft' },
  { value: FINANCE_AND_INSURANCE_SECTOR, label: 'Finanz- und Versicherungsdienstleistungen' },
  {
    value: REAL_ESTATE_SECTOR,
    label: 'Grundstücks- und Wohnungswesen sowie Vermietung und Verleih',
  },
  {
    value: SCIENTIFIC_SERVICES_SECTOR,
    label: 'Freiberufliche, wissenschaftliche und technische Dienstleistungen',
  },
  {
    value: MANAGEMENT_OF_COMPANIES_SECTOR,
    label: 'Führung von Unternehmen und Betrieben',
  },
  {
    value: ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
    label: 'Administrative und Unterstützungsleistungen sowie Abfallwirtschaft und Sanierungsdienste',
  },
  { value: EDUCATIONAL_SERVICES_SECTOR, label: 'Bildungsdienstleistungen' },
  { value: HEALTH_CARE_SECTOR, label: 'Gesundheits- und Sozialwesen' },
  {
    value: ARTS_ENTERTAINMENT_SECTOR,
    label: 'Kunst, Unterhaltung und Erholung',
  },
  {
    value: ACCOMMODATION_SERVICES_SECTOR,
    label: 'Beherbergungs- und Gastronomiedienstleistungen',
  },
  {
    value: OTHER_SERVICES_SECTOR,
    label: 'Sonstige Dienstleistungen (ohne öffentliche Verwaltung)',
  },
  { value: PUBLIC_ADMINISTRATION_SECTOR, label: 'Öffentliche Verwaltung' },
];
